import { ArpeggioDeviceBox, GrooveShuffleBox, PitchDeviceBox, SpielwerkDeviceBox, VelocityDeviceBox, ZeitgeistDeviceBox } from "@opendaw/studio-boxes";
import { asInstanceOf, panic } from "@opendaw/lib-std";
import { EffectFacade } from "./EffectChain";
import { Facades } from "../Facades";
import { GrooveShuffleImpl } from "../GrooveShuffleImpl";
import { ScriptSupport } from "./ScriptDevices";
export class MIDIEffectFacade extends EffectFacade {
    get audioUnit() { return Facades.audioUnitOf(this.context, this.box); }
}
export class ArpeggioEffectImpl extends MIDIEffectFacade {
    key = "Arpeggio";
    constructor(context, box) {
        super(context, box);
        this.bind({
            mode: box.modeIndex, octaves: box.numOctaves, rate: box.rateIndex,
            gate: box.gate, repeat: box.repeat, velocity: box.velocity
        });
    }
}
export class PitchEffectImpl extends MIDIEffectFacade {
    key = "Pitch";
    constructor(context, box) {
        super(context, box);
        this.bind({ octaves: box.octaves, semiTones: box.semiTones, cents: box.cents });
    }
}
export class VelocityEffectImpl extends MIDIEffectFacade {
    key = "Velocity";
    constructor(context, box) {
        super(context, box);
        this.bind({
            magnetPosition: box.magnetPosition, magnetStrength: box.magnetStrength, randomSeed: box.randomSeed,
            randomAmount: box.randomAmount, offset: box.offset, mix: box.mix
        });
    }
}
export class ZeitgeistEffectImpl extends MIDIEffectFacade {
    key = "Zeitgeist";
    constructor(context, box) { super(context, box); }
    get groove() {
        const grooveBox = this.box.groove.targetVertex.unwrap("Zeitgeist has no groove").box;
        return GrooveShuffleImpl.wrap(this.context, asInstanceOf(grooveBox, GrooveShuffleBox));
    }
}
export class SpielwerkEffectImpl extends MIDIEffectFacade {
    key = "Spielwerk";
    #script;
    constructor(context, box) {
        super(context, box);
        this.#script = new ScriptSupport(context, box, "spielwerk");
    }
    get code() { return this.#script.code; }
    set code(source) { this.#script.code = source; }
    get parameters() { return this.#script.parameters; }
    get samples() { return this.#script.samples; }
    parameter(label) { return this.#script.parameter(label); }
    sample(label) { return this.#script.sample(label); }
}
export var MIDIEffectImpls;
(function (MIDIEffectImpls) {
    MIDIEffectImpls.wrap = (context, box) => context.facade(box, () => {
        if (box instanceof ArpeggioDeviceBox) {
            return new ArpeggioEffectImpl(context, box);
        }
        if (box instanceof PitchDeviceBox) {
            return new PitchEffectImpl(context, box);
        }
        if (box instanceof VelocityDeviceBox) {
            return new VelocityEffectImpl(context, box);
        }
        if (box instanceof ZeitgeistDeviceBox) {
            return new ZeitgeistEffectImpl(context, box);
        }
        if (box instanceof SpielwerkDeviceBox) {
            return new SpielwerkEffectImpl(context, box);
        }
        return panic(`${box.name} is not a supported midi-effect`);
    });
    MIDIEffectImpls.isBox = (box) => box instanceof ArpeggioDeviceBox || box instanceof PitchDeviceBox || box instanceof VelocityDeviceBox
        || box instanceof ZeitgeistDeviceBox || box instanceof SpielwerkDeviceBox;
})(MIDIEffectImpls || (MIDIEffectImpls = {}));
